export interface TooltipItem {
  datasetIndex: number;
  yLabel: string;
}

/** Minimal Chart.js-like `data` shape for tooltip label formatting. */
export interface ChartLikeData {
  datasets?: {label?: string}[];
}

export function formatNumberLabel(
  tooltipItem: TooltipItem | undefined,
  data: ChartLikeData | undefined,
): string {
  if (!tooltipItem || !data?.datasets) {
    return '';
  }
  const dataset = data.datasets[tooltipItem.datasetIndex];
  if (!dataset) {
    return '';
  }
  let label = dataset.label ?? '';
  if (label) {
    label += ': ';
  }
  const yNum = Number(tooltipItem.yLabel);
  const valuePart =
    Number.isFinite(yNum) && yNum >= 1000
      ? yNum.toLocaleString()
      : tooltipItem.yLabel;
  label += valuePart;
  return label;
}
